import React from 'react';

const IconMicrosoft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    className="feather feather-microsoft">
    <title>Microsoft</title>
    <rect x="1" y="1" width="10" height="10" fill="#f25022" />
    <rect x="13" y="1" width="10" height="10" fill="#7fba00" />
    <rect x="1" y="13" width="10" height="10" fill="#00a4ef" />
    <rect x="13" y="13" width="10" height="10" fill="#ffb900" />
  </svg>
);

export default IconMicrosoft;
